import {
  GET_ORGANIZATION_IAAC,
  GET_ORGANIZATION_IAAC_SUCCESSFUL,
  GET_ORGANIZATION_IAAC_FAILURE,
  POST_ORGANIZATION_IAAC,
  POST_ORGANIZATION_IAAC_SUCCESSFUL,
  POST_ORGANIZATION_IAAC_FAILURE,
  PUT_ORGANIZATION_IAAC,
  PUT_ORGANIZATION_IAAC_SUCCESSFUL,
  PUT_ORGANIZATION_IAAC_FAILURE,
  DELETE_ORGANIZATION_IAAC,
  DELETE_ORGANIZATION_IAAC_SUCCESSFUL,
  DELETE_ORGANIZATION_IAAC_FAILURE,
  CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES,
  CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES_SUCCESSFUL

} from "./actionTypes";

export const getOrganizationIaac = (orgCode) => {
  console.log("getOrganizationIaac for orgCode: ", orgCode);
  return {
    type: GET_ORGANIZATION_IAAC,
    payload: { orgCode }
  }
}

export const getOrganizationIaacSuccessful = (iaac) => {
  console.log("getOrganizationIaacSuccessful with iaac: ", iaac);
  return {
    type: GET_ORGANIZATION_IAAC_SUCCESSFUL,
    payload: { iaac }
  }
}

export const getOrganizationIaacFailure = (getOrganizationIaacError) => {
  console.log("getOrganizationIaacFailure with error: ", getOrganizationIaacError);
  return {
    type: GET_ORGANIZATION_IAAC_FAILURE,
    payload: { getOrganizationIaacError }
  }
}

export const postOrganizationIaac = (orgCode, iaacRequest) => {
  console.log("postOrganizationIaac with orgCode:", orgCode," and iaac:", iaacRequest);
  return {
    type: POST_ORGANIZATION_IAAC,
    payload: { orgCode, iaacRequest }
  };
}

export const postOrganizationIaacSuccessful = (iaac) => {
  console.log("postOrganizationIaacSuccessful with iaac:", iaac);
  return {
    type: POST_ORGANIZATION_IAAC_SUCCESSFUL,
    payload: { iaac }
  };
}

export const postOrganizationIaacFailure = (createOrganizationIaacError) => {
  console.log("postOrganizationIaacFailure with error:", createOrganizationIaacError);
  return {
    type: POST_ORGANIZATION_IAAC_FAILURE,
    payload: { createOrganizationIaacError }
  };
}

export const putOrganizationIaac = (orgCode, iaacRequest, subscriptionChange) => {
  console.log("putOrganizationIaac with orgCode:", orgCode,
    " and iaac:", iaacRequest, " subscriptionChange:", subscriptionChange);
  return {
    type: PUT_ORGANIZATION_IAAC,
    payload: { orgCode, iaacRequest, subscriptionChange }
  }
}

export const putOrganizationIaacSuccessful = (updateOrganizationIaacMessage) => {
  console.log("putOrganizationIaacSuccessful with iaac:", updateOrganizationIaacMessage);
  return {
    type: PUT_ORGANIZATION_IAAC_SUCCESSFUL,
    payload: { updateOrganizationIaacMessage }
  }
}

export const putOrganizationIaacFailure = (updateOrganizationIaacError) => {
  console.log("putOrganizationIaacFailure with error:", updateOrganizationIaacError);
  return {
    type: PUT_ORGANIZATION_IAAC_FAILURE,
    payload: { updateOrganizationIaacError }
  }
}

export const deleteOrganizationIaac = (orgCode) => {
  console.log("deleteOrganizationIaac with orgCode:", orgCode);
  return {
    type: DELETE_ORGANIZATION_IAAC,
    payload: { orgCode }
  }
}

export const deleteOrganizationIaacSuccessful = (deleteOrganizationIaacMessage) => {
  console.log("deleteOrganizationIaacSuccessful with deleteOrganizationIaacMessage:", deleteOrganizationIaacMessage);
  return {
    type: DELETE_ORGANIZATION_IAAC_SUCCESSFUL,
    payload: { deleteOrganizationIaacMessage }
  }
}

export const deleteOrganizationIaacFailure = (deleteOrganizationIaacError) => {
  console.log("deleteOrganizationIaacFailure with error:", deleteOrganizationIaacError);
  return {
    type: DELETE_ORGANIZATION_IAAC_FAILURE,
    payload: { deleteOrganizationIaacError }
  }
}

export const clearAllOrganizationIaacMessages = () => {
  return {
    type: CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES,
    payload: {},
  };
};

export const clearAllOrganizationIaacMessagesSuccessful = () => {
  return {
    type: CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES_SUCCESSFUL,
    payload: {},
  };
};